import createTypenameTypeguard from "../createTypenameTypeguard";

export const isBlocksAthleteQuoteStack = createTypenameTypeguard(
  "BlocksAthleteQuoteStack",
);

export const isBlocksCompanyStage =
  createTypenameTypeguard("BlocksCompanyStage");

export const isBlocksHighlightsStage = createTypenameTypeguard(
  "BlocksHighlightsStage",
);

export const isBlocksIngredientsStage = createTypenameTypeguard(
  "BlocksIngredientsStage",
);

export const isBlocksinteractiveHero = createTypenameTypeguard(
  "BlocksinteractiveHero",
);

export const isLifecyclePhase = createTypenameTypeguard("LifecyclePhase");

export const isBlocksPcsMoodboard =
  createTypenameTypeguard("BlocksPcsMoodboard");

export const isBlocksOccasionStack = createTypenameTypeguard(
  "BlocksOccasionStack",
);

export const isBlocksProductDescription = createTypenameTypeguard(
  "BlocksProductDescription",
);

export const isBlocksProductHeroCan = createTypenameTypeguard(
  "BlocksProductHeroCan",
);

export const isBlocksProductRail = createTypenameTypeguard("BlocksProductRail");

export const isBlocksProductStage =
  createTypenameTypeguard("BlocksProductStage");

export const isBlocksQaArticle = createTypenameTypeguard("BlocksQaArticle");

export const isBlocksQaStage = createTypenameTypeguard("BlocksQaStage");

export const isArtwork = createTypenameTypeguard("Artwork");

export const isSupportModule = createTypenameTypeguard("SupportModule");

export const isButton = createTypenameTypeguard("Button");

export const isSearchField = createTypenameTypeguard("SearchField");

export const isContactAssistant = createTypenameTypeguard("ContactAssistant");

export const isBlocksWorbCarousel =
  createTypenameTypeguard("BlocksWorbCarousel");

export const isBlocksWorbRail = createTypenameTypeguard("BlocksWorbRail");

export const isAsset = createTypenameTypeguard("Asset");

export const isImage = createTypenameTypeguard("Image");

export const isBlocksCartoonsOccasionStack = createTypenameTypeguard(
  "BlocksCartoonsOccasionStack",
);

export const isPreviewClip = createTypenameTypeguard("PreviewClip");

export const isMediabaseDeliveryAgentClips = createTypenameTypeguard(
  "MediabaseDeliveryAgentClips",
);
